import React from 'react';
import { CheckboxProps } from 'ui/checkboxV2';

export type BorderedCheckboxGroupProps = Omit<CheckboxGroupProps, 'type'>;

export type CheckboxGroupProps = {
  /**
   *  Whether the group is stacked vertically or horizontally.
   *  In cases where options may need to stacked horizontally,
   *  the options are limited to 2 Checkbox items per row.
   */
  direction?: Direction;
  /** If this Boolean attribute is set,
   * all checkboxes part of the group are disabled, meaning they are not editable. */
  isDisabled?: boolean;
  /** The name associated with the group. */
  name?: string;
  options: Option[];
  /**
   * Bordered checkbox groups have additional styling associated with them.
   */
  type?: Type;
};

export enum Direction {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}

export enum Type {
  Bordered = 'bordered',
  Default = 'default',
}

export type Option = {
  /** if the checkbox has an error associated with it */
  hasError?: boolean;
  /** the optional label component displayed on the right side of the checkbox */
  Label?: React.ReactNode;
} & CheckboxProps;
